<template>
  <div>
    <v-card rounded outlined>
      <div class="d-flex" style="overflow:hidden;">
        <div class="blue-grey" style="width:9px;">
          &nbsp;
        </div>
        <div :style="{width:'100%',maxHeight:showDetails ? '64px':null}" @click="toggleDetails" :class="{'param-title':true, 'param-title-selected':showDetails}">
          <v-card-title>
            {{ $t('result.roles.title') }}
            <v-spacer></v-spacer>
            <div class="d-flex align-center">
              <score-bar
                  v-if="showDetails"
                  :options="{type:'title_bar',values:[],scale:2}"
              ></score-bar>
              <a class="subtitle-2 ml-2" style="text-decoration: none" href="javascript:void(0)">
                <span v-if="showDetails">{{$t('result.toggle_summary')}}</span>
                <span v-else>{{$t('result.toggle_detail')}}</span>
              </a>
            </div>
          </v-card-title>

          <!-- summary content -->
          <div class="px-5 mb-5">
            <!-- SMALL -->
            <v-card v-if="!showDetails" flat rounded class="d-sm-none">
              <v-card-text class="pa-0 d-flex justify-center">
                <v-row>
                  <v-col class="pa-0" cols="12" sm="4" v-for="(box,key) in roles.boxes" :key="key">
                    <v-card elevation="0" class="pa-0">
                      <v-card-text class="text-center pa-1">
                        <span class="subtitle-1 font-weight-bold">{{ $t('result.roles.boxes.'+key+'.title') }}</span>
                        <v-sheet rounded :height="6" :color="colors[key]" class="mt-2"></v-sheet>
                      </v-card-text>
                      <v-card-text class="pa-1">
                        <p v-for="(item,key) in box" :key="key" class="text-center my-2" style="text-transform: uppercase">
                          {{$t('result.roles.items.'+item+'.title')}}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- NORMAL -->
            <v-card v-if="!showDetails" flat rounded class="d-none d-sm-block">
              <v-card-text class="py-5 d-flex justify-center">
                <v-row>
                  <v-col cols="12" sm="4" v-for="(box,key) in roles.boxes" :key="key">
                    <v-card elevation="0">
                      <v-card-text class="text-center pb-0">
                        <span class="subtitle-1 font-weight-bold">{{ $t('result.roles.boxes.'+key+'.title') }}</span>
                        <v-sheet rounded :height="6" :color="colors[key]" class="mt-2"></v-sheet>
                      </v-card-text>
                      <v-card-text>
                        <p v-for="(item,key) in box" :key="key" class="text-center my-2" style="text-transform: uppercase">
                          {{$t('result.roles.items.'+item+'.title')}}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </div>

      </div>
      <div v-if="showDetails">
        <v-divider></v-divider>
        <div>
          <v-card-text class="py-5">
            <!-- Boxes -->
            <v-row>
              <v-col cols="12" sm="4" v-for="(box,key) in roles.boxes" :key="key">
                <v-card outlined elevation="0">
                  <v-card-text class="text-center pb-0 back_accent">
                    <span class="subtitle-1 font-weight-bold">{{ $t('result.roles.boxes.'+key+'.title') }}</span>
                    <v-sheet rounded :height="6" :color="colors[key]" class="mt-2"></v-sheet>
                  </v-card-text>
                  <v-list dense>
                    <v-list-item-group
                        v-model="selectedItem[key]"
                        color="primary"
                    >
                      <v-list-item
                          @click="selectedItem = {}"
                          color="blue-grey"
                          v-for="(item,ikey) in box" :key="ikey"
                      >
                        <v-list-item-content class="text-center">
                          <v-list-item-title
                              v-text="$t('result.roles.items.'+item+'.title')"
                              style="text-transform: uppercase"
                          >
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon v-if="selectedItem[key] === ikey">
                          <v-icon>mdi-close</v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>

            <!--insights-->
            <div class="mt-5 bm-page-break">
              <span class="subtitle-1">{{$t('result.roles.insights')}}</span>
              <v-divider></v-divider>
            </div>
            <!-- filter -->
            <div class="mb-2">
              <v-row justify="space-around" class="ma-0 d-print-none">
                <div class="pa-2 d-flex align-center">
                  <v-chip
                      v-if="filter"
                      @click="filter = null"
                      class="mr-2"
                      small
                      outlined
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-chip>
                  <div class="d-inline">
                    <v-chip-group
                        class="align-center text-center d-flex"
                        v-model="filter"
                        column
                        active-class="accent--text"
                    >
                      <v-chip
                          v-for="(flt,ftkey,index) in filters"
                          :key="ftkey"
                          :value="flt.id"
                          small
                          filter
                          label
                          outlined
                      >
                        {{ flt.title }}
                      </v-chip>
                    </v-chip-group>
                  </div>
                </div>
              </v-row>
            </div>

            <!-- item list -->
            <div>
              <v-card
                  v-if="!itemFilter.active || itemFilter.box === group.color"
                  class="mb-5"
                  outlined
                  elevation="0"
                  v-for="(group,gkey, index) in [ {color: 'green', value: 3}, {color:'yellow', value:2}, {color:'red', value: 1} ]"
                  :key="'item-group-'+gkey">
                <v-alert
                    v-if="!itemFilter.active"
                    text
                    :color="colors[group.color]"
                    class="mb-0 pa-0"
                >
                  <div class="d-flex">
                    <div :style="{width:'8px',backgroundColor:colors[group.color]}">
                    </div>
                    <div class="grow px-2 py-5" v-if="filter">
                      <span class="text--primary subtitle-1 font-weight-bold">{{$t('result.roles.attributes.'+filter+'.'+group.value)}}</span>
                      <br><span class="caption text--secondary">{{$t('result.roles.attributes.'+filter+'.tooltips.'+group.value)}}</span>
                    </div>
                    <div class="grow px-2 py-5" v-else>
                      <span class="text--primary subtitle-1 font-weight-bold">{{$t('result.roles.boxes.'+group.color+'.title')}}</span>
                      <br><span class="caption text--secondary">{{$t('result.roles.boxes.'+group.color+'.text')}}</span>
                    </div>
                  </div>
                </v-alert>
                <div
                    v-if="!itemFilter.active || (itemFilter.box === group.color && itemFilter.item === ilkey)"
                    :class="{ 'pb-2 mt-2 bm-page-break-inside': !filter }"
                    v-for="(itemlist,ilkey) in 4"
                    :key="ilkey">
                    <div class="back_accent d-flex" v-if="!filter">
                      <div :style="{width:'8px',backgroundColor:colors[group.color]}">
                      </div>
                      <div class="pa-2">
                        <span class="subtitle-1 mr-2">{{ $t('result.roles.items.'+roles.boxes[group.color][ilkey]+'.title') }}</span>
                        <br class="d-sm-none"/>
                        <v-icon :color="getItemTeamLead(roles.boxes[group.color][ilkey]).teamwork.color" small class="mr-1">{{getItemTeamLead(roles.boxes[group.color][ilkey]).teamwork.icon}}</v-icon> <span style="text-transform: lowercase" class="caption mr-2">{{getItemTeamLead(roles.boxes[group.color][ilkey]).teamwork.text}} {{$t('result.roles.leadership.title')}}</span>
                        <v-icon :color="getItemTeamLead(roles.boxes[group.color][ilkey]).leadership.color" small  class="mr-1">{{getItemTeamLead(roles.boxes[group.color][ilkey]).leadership.icon}}</v-icon> <span style="text-transform: lowercase" class="caption mr-2">{{getItemTeamLead(roles.boxes[group.color][ilkey]).leadership.text}} {{$t('result.roles.teamwork.title')}}</span>
                        <br><span class="caption">{{ $t('result.roles.items.'+roles.boxes[group.color][ilkey]+'.description') }}</span>
                      </div>
                    </div>
                    <v-list-item
                        style="min-height: auto;"
                        class="px-5 py-1"
                        two-line
                        v-for="(attribute, akey) in [1,3,4,2]"
                        :key="akey"
                        v-if="!filter || (filter && filter === attribute)"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-title v-if="filter" class="body-2">{{ $t('result.roles.items.'+roles.boxes[group.color][ilkey]+'.title') }}</v-list-item-title>
                        <v-list-item-title v-else class="body-2">{{ $t('result.roles.attributes.'+attribute+'.title') }}</v-list-item-title>
                        <v-list-item-subtitle>{{ $t('result.roles.items.'+roles.boxes[group.color][ilkey]+'.attribute'+attribute) }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                </div>

              </v-card>

            </div>


          </v-card-text>
        </div>
      </div>

    </v-card>
  </div>
</template>

<script>
  export default {
    name: "Motivation",
    props: ['roles'],
    components: {
      ScoreBar: () => import('../components/ScoreBar'),
    },
    data() {
      return {
        selectedItem: {},
        showDetails: false,
        ae_keys: {
          0: "leadership", // result2
          1: "teamwork" // result1
        },
        score_meta: {
          0: {color:'#ddd',state:'mid'},
          1: {color:'#ddd',state:'mid'}
        },
        ae_states: {
          "low":"1.0-2.9",
          "mlow":"3.0-4.9",
          "mid":"5.0-6.9",
          "mhigh":"7.0-8.9",
          "high":"9.0-10"
        },
        scoreColor: 'transparent',
        items:{
          15:{'result1' : 1, 'result2' : 3}, //vytrvalec
          12:{'result1' : 3, 'result2' : 3}, //stmelovac
          9:{'result1' : 1, 'result2' : 2}, //tahount
          6:{'result1' : 3, 'result2' : 2}, //komunikator
          17:{'result1' : 3, 'result2' : 1}, //diplomat
          4:{'result1' : 1, 'result2' : 1}, //vykonavatel
          1:{'result1' : 2, 'result2' : 1}, //strateg
          7:{'result1' : 3, 'result2' : 3}, //vudce
          8:{'result1' : 2, 'result2' : 3}, //vizionar
          14:{'result1' : 1, 'result2' : 2}, //objevitel
          13:{'result1' : 2, 'result2' : 2}, //zlepsovatel
          18:{'result1' : 2, 'result2' : 1} //propagator
        },
        itemValues: {
          icon: {
            1: 'mdi-arrow-down-bold-circle',
            2: 'mdi-arrow-right-bold-circle',
            3: 'mdi-arrow-up-bold-circle'
          },
          "result2":{
            1:this.$t('result.roles.leadership.state.mlow.title'),
            2:this.$t('result.roles.leadership.state.mid.title'),
            3:this.$t('result.roles.leadership.state.mhigh.title')
          },
          "result1":{
            1:this.$t('result.roles.teamwork.state.mlow.title'),
            2:this.$t('result.roles.teamwork.state.mid.title'),
            3:this.$t('result.roles.teamwork.state.mhigh.title')
          }
        },
        itemFilter: {
          active:false,
          box: null,
          item: null
        },
        filter: null,
        filters: {
          1: {title:this.$t('result.roles.attributes.1.title'), id: 1},
          2: {title:this.$t('result.roles.attributes.3.title'), id: 3},
          3: {title:this.$t('result.roles.attributes.4.title'), id: 4},
          4: {title:this.$t('result.roles.attributes.2.title'), id: 2}
        },
      }
    },
    computed: {
      colors() {
        return this.$store.getters['app/colors']
      },
      legends() {
        return this.$store.getters['app/legends']
      },
      showAll(){
        return this.$store.getters['diagnostic/showAll']
      }
    },
    methods: {
      getItemTeamLead(item) {
        let result = {
          teamwork: {
            icon:'',
            text: '',
            color: ''
          },
          leadership: {
            icon:'',
            text: '',
            color: ''
          }
        }
        if (this.items[item]) {
          let tscore = this.items[item]['result2']
          result.teamwork.icon = this.itemValues.icon[tscore]
          result.teamwork.text = this.itemValues.result2[tscore]
          switch(tscore){
            case 1:
              result.teamwork.color = this.colors['red']
              break;
            case 2:
              result.teamwork.color = this.colors['yellow']
              break;
            case 3:
              result.teamwork.color = this.colors['green']
              break;
          }

          let lscore = this.items[item]['result1']
          result.leadership.icon = this.itemValues.icon[lscore]
          result.leadership.text = this.itemValues.result1[lscore]
          switch(lscore){
            case 1:
              result.leadership.color = this.colors['red']
              break;
            case 2:
              result.leadership.color = this.colors['yellow']
              break;
            case 3:
              result.leadership.color = this.colors['green']
              break;
          }
        }
        return result
      },
      toggleDetails() {
        this.showDetails = !this.showDetails
        this.selectedItem = {}
        this.itemFilter.active = false
      },
      resetOtherFilters() {
        this.selectedItem = {}
        this.itemFilter.active = false
      },
       getScoreMeta() {
         let scores = [this.roles.totalScores.result2, this.roles.totalScores.result1]

         //summary color left stripe
         this.$store.dispatch('app/getSummaryColor',{scores:scores,type:2}).then(score_color => {
           this.scoreColor = score_color
         })

         //result colors
         for (let item in scores) {
           this.$store.dispatch('app/getSummaryColor',{scores:[scores[item]],type:2}).then(score_color => {
             this.score_meta[item].color = score_color
           })
           if (scores[item] < 3) {
             this.score_meta[item].state = 'low'
           } else if (scores[item] < 5) {
             this.score_meta[item].state = 'mlow'
           } else if (scores[item] < 7) {
             this.score_meta[item].state = 'mid'
           } else if (scores[item] < 9) {
             this.score_meta[item].state = 'mhigh'
           } else {
             this.score_meta[item].state = 'high'
           }
         }
      },
      scoreNum(score){
        if (score < 9.947) {
          return score.toFixed(1)
        } else {
          return 10
        }
      }
    },
    created() {
      this.showDetails = this.showAll
      this.getScoreMeta()
    },
    watch: {
      showAll: function(val) {
        this.showDetails = val
      },
      selectedItem: function(val) {
        let key = Object.keys(val)[0]
        let value = val[key]
        if (this.filter && val.active === true) {
          this.filter = null
        }
        if (value >=0) {
          this.itemFilter.box = key
          this.itemFilter.item = value
          this.itemFilter.active = true
        } else {
          this.itemFilter.active = false
        }
      },
      filter: function(val) {
        if (this.itemFilter.active === true && this.filter) {
          this.itemFilter.active = false
          this.selectedItem = {}
        }
      }
    }
  }
</script>
